import React from "react";

import styles from "./StepFooter.module.scss";
import block from 'bem-css-modules';
import { Footer } from "./StepFooter.types"

import { sanitizeContent as s, replaceVariablesInText } from "../../../util/functions";

const StepFooter = (props: Footer) => {
  const { text } = props;

  const b = block(styles);

  const processedContent = text ? replaceVariablesInText(text) : "";

  return (
    <div className={`fc-step-footer ${b()}`}>
      {text && (
      <div
        className={b("text")}
        dangerouslySetInnerHTML={{ __html: s(processedContent) }} />
      )}
      
    </div>
  )
}

export default StepFooter;